import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { getUrl, ResourceUri } from '@ngxp/rest';
import { changeFileAction, changeFileSuccessAction, FileType } from '@schir-int-client/binary-shared';
import { doIfLoadingRequired, StateResource } from '@schir-int-client/ngrx-helpers';
import { AufgabeLinkRel } from 'libs/aufgabe-shared/src/lib/aufgabe.linkrel';
import { AufgabeResource } from 'libs/aufgabe-shared/src/lib/aufgabe.model';
import { AufgabeRootState } from 'libs/aufgabe-shared/src/lib/aufgabe.state';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { askToDeleteKorrespondenzVorlageAction, loadKorrespondenzVorlageAction } from './korrespondenz-vorlage.actions';
import { KorrespondenzVorlageLinkRel } from './korrespondenz-vorlage.linkrel';
import { KorrespondenzVorlageResource } from './korrespondenz-vorlage.model';
import { korrespondenzVorlageSelector } from './korrespondenz-vorlage.selectors';

@Injectable({ providedIn: 'root' })
export class KorrespondenzVorlageFacade {
	constructor(
		private store: Store<AufgabeRootState>,
		private actions$: Actions
	) {}

	readonly changeFileSuccess$: Observable<ReturnType<typeof changeFileSuccessAction>> = this.actions$.pipe(
		ofType(changeFileSuccessAction)
	);

	deleteKorrespondenzVorlage(korrespondenzVorlage: KorrespondenzVorlageResource) {
		this.store.dispatch(askToDeleteKorrespondenzVorlageAction({ korrespondenzVorlage }));
	}

	uploadKorrespondenzVorlage(korrespondenzVorlage: KorrespondenzVorlageResource, file: File) {
		this.store.dispatch(
			changeFileAction({
				resource: korrespondenzVorlage,
				linkRel: KorrespondenzVorlageLinkRel.UPLOAD_FILE,
				fileType: FileType.KORRESPONDENZ,
				file,
			})
		);
	}

	getKorrespondenzVorlageByAufgabe(
		aufgabe: AufgabeResource
	): Observable<StateResource<KorrespondenzVorlageResource>> {
		const korrespondenzVorlageUri: ResourceUri = getUrl(aufgabe, AufgabeLinkRel.KORRESPONDENZ_VORLAGE);
		return this.store
			.select(korrespondenzVorlageSelector(korrespondenzVorlageUri))
			.pipe(
				filter(
					korrespondenzVorlageStateResource =>
						!doIfLoadingRequired(korrespondenzVorlageStateResource, () =>
							this.store.dispatch(loadKorrespondenzVorlageAction({ aufgabe }))
						)
				)
			);
	}
}
